import * as moment from 'moment/moment';

export class StockTransferModel {
  constructor() {
    this.type,
      (this.date = moment().format('YYYY-MM-DD')),
      this.Id,
      this.batch,
      this.reference_number,
      (this.statusNote = null),
      this.statusChange,
      (this.statusNoteChange = null),
      this.unit,
      (this.selectedProduct = { batches: [] });
    (this.from_shop_id = null),
      (this.shopTransferItems = { transferitems: [] });
    (this.to_shop_id = null),
      this.selectedBatch,
      this.selectedunit,
      (this.items = []),
      (this.quantity = 0);
    this.maxQuantity = 0;
  }
}
